import { useEffect } from 'react';
import { useAuth, useTenantsState, useTenantsActions } from '@frontegg/react';
import { useSetAtom } from 'jotai';
import { isDebugMode } from '../../debug/debugUser';
import { customerTenantIdState } from '../state/AuthState';
import { resolveCustomerTenantId } from './tenantSubdomain';

/**
 * Keeps `customerTenantIdState` in step with the host on every authenticated
 * route, including the ones that render without the navbar. Owns the tenant
 * list load that this hook and the account switcher both read.
 */
/* eslint-disable react-hooks/rules-of-hooks -- isDebugMode is constant for the app lifetime (same pattern as useAccountSwitcher) */
export function useCustomerTenantSync(): void {
  if (isDebugMode()) {
    return;
  }
  const { user } = useAuth();
  const { tenants } = useTenantsState();
  const { loadTenants } = useTenantsActions();
  const setCustomerTenantId = useSetAtom(customerTenantIdState);

  const userTenantIds = user?.tenantIds;
  const hasMultipleMemberships = (userTenantIds?.length ?? 0) > 1;
  const ownTenantId = user?.tenantId;

  // Only users with several memberships need the list; a single-tenant user's
  // customer is their own tenant
  useEffect(() => {
    if (userTenantIds && userTenantIds.length > 1) {
      loadTenants();
    }
  }, [userTenantIds, loadTenants]);

  useEffect(() => {
    setCustomerTenantId(resolveCustomerTenantId(tenants, hasMultipleMemberships, ownTenantId));
  }, [tenants, hasMultipleMemberships, ownTenantId, setCustomerTenantId]);
}
/* eslint-enable react-hooks/rules-of-hooks */
